module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ChapTitle1"
  }, [_c('a', {
    attrs: {
      "id": "HLD4"
    }
  }), _vm._v("Block Index")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("8˝ × 8˝ Blocks")]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("The blocks in this section will measure 8½˝ × 8½˝ including a ¼˝ seam allowance on each side. Once they are sewn into a project, the finished blocks will measure 8˝ × 8˝.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/26_chapter22#HLD24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apartment")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/31_chapter27#HLD29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clock Tower")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter06#HLD8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crosswalk")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('a', {
    attrs: {
      "href": "#/09_chapter05#HLD7"
    }
  }, [_vm._v("Donut Shop")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/25_chapter21#HLD23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drawbridge")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/21_chapter17#HLD19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Duplex")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/19_chapter15#HLD17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elevator")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_8.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter12#HLD14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Favorite Sweater")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_9.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter14#HLD16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fence")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_10.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/30_chapter26#HLD28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Food Truck")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_11.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('a', {
    attrs: {
      "href": "#/08_chapter04#HLD6"
    }
  }, [_vm._v("Forest Park")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_12.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter07#HLD9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Intercom")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_13.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter08#HLD10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Intersection")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_14.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/23_chapter19#HLD21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Library")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_15.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/32_chapter28#HLD30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lobby")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_16.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter11#HLD13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mini Storage")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_17.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/28_chapter24#HLD26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mixed Use")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_18.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/20_chapter16#HLD18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Museum")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_19.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter10#HLD12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Porch")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_20.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/27_chapter23#HLD25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("River Walk")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_21.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/29_chapter25#HLD27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roadblock")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_22.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/22_chapter18#HLD20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spotlight")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_23.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/24_chapter20#HLD22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Streetlight")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_24.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter13#HLD15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sushi")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_25.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter09#HLD11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Transit Center")])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("5˝ × 8˝ Blocks")]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("The blocks in this section will measure 5½˝ × 8½˝ including a ¼˝ seam allowance on each side. Once they are sewn into a project, the finished blocks will measure 5˝ × 8˝.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/56_chapter52#HLD56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Airport")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/49_chapter45#HLD49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bowling Alley")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/39_chapter35#HLD39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Emergency Exit")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/55_chapter51#HLD55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fortune Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/34_chapter30#HLD34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Half Sandwich")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/40_chapter36#HLD40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("House Plant")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/50_chapter46#HLD50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Karaoke")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_8.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/44_chapter40#HLD44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kiosk")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_9.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/43_chapter39#HLD43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Magazine Rack")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_10.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/42_chapter38#HLD42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meow")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_11.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/36_chapter32#HLD36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Onramp")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_12.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/33_chapter29#HLD33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parking Garage")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_13.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/45_chapter41#HLD45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parking Meters")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_14.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/37_chapter33#HLD37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Planter Box")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_15.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/52_chapter48#HLD52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Raindrops")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_16.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/35_chapter31#HLD35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rec Center")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_17.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/47_chapter43#HLD47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rose Garden")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_18.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/38_chapter34#HLD38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sequins")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_19.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/54_chapter50#HLD54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sidewalk")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_20.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/57_chapter53#HLD57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Skyline")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_21.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/53_chapter49#HLD53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stripey Socks")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_22.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/48_chapter44#HLD48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Supermarket")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_23.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/51_chapter47#HLD51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traffic Cones")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_24.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/46_chapter42#HLD46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turnstile")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_25.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/41_chapter37#HLD41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waterfront")])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("5˝ × 14˝ Blocks")]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("The blocks in this section will measure 5½˝ × 14½˝ including a ¼˝ seam allowance on each side. Once they are sewn into a project, the finished blocks will measure 5˝ × 14˝.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/70_chapter66#HLD75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Auditorium")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/78_chapter74#HLD83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Balcony")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/68_chapter64#HLD73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bookstore")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/60_chapter56#HLD65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brewery")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/61_chapter57#HLD66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carpool")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/58_chapter54#HLD63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("City Hall")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/64_chapter60#HLD69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coffee Shop")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_8.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/73_chapter69#HLD78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cornerstone")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_9.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/76_chapter72#HLD81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Corrugated Cardboard")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_10.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/82_chapter78#HLD87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Do Not Enter")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_11.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/62_chapter58#HLD67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dog Park")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_12.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/63_chapter59#HLD68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Escalator")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_13.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/65_chapter61#HLD70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haircut")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_14.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/81_chapter77#HLD86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Laundromat")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_15.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/69_chapter65#HLD74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Look Both Ways")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_16.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/71_chapter67#HLD76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Post Office Box")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_17.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/79_chapter75#HLD84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Puddles")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_18.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/75_chapter71#HLD80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Restaurant")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_19.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/66_chapter62#HLD71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Skylight")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_20.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/74_chapter70#HLD79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stadium")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_21.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/67_chapter63#HLD72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Storefront")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_22.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/77_chapter73#HLD82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tiki Bar")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_23.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/80_chapter76#HLD85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tow-Away Zone")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_24.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/72_chapter68#HLD77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Window Washer")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_25.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('span', {
    attrs: {
      "href": "#/59_chapter55#HLD64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zoo Train")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a759df0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_chapter02.vue
// module id = 69
// module chunks = 0